var sliderSections = document.querySelectorAll(".slider-container");
sliderSections.forEach(function (element) {
  initializeSliders(element);
});

var productRecommendationsData = document.querySelectorAll(
  ".product-recommendation-data"
);
productRecommendationsData.forEach(function (element) {
  var handleIntersection = function (entries, observer) {
    if (!entries[0].isIntersecting) {
      return;
    }
    observer.unobserve(element);
    var url = element.dataset.url;
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement("div");
        html.innerHTML = text;
        var recommendations = html.querySelector("[data-recommendation]");
        if (recommendations && recommendations.innerHTML.trim().length) {
          element.innerHTML = recommendations.innerHTML;

          var recommendationSliderSections = element.querySelectorAll(
            ".recommendation-slider-container"
          );
          recommendationSliderSections.forEach(function (element) {
            initializeSliders(element);
          });
        }
      })
      .catch(function (e) {
        console.error(e);
      });
  };

  var observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 1000px 0px"
  });

  observer.observe(element);
});

function initializeSliders(container) {
  const autoSlideEnabled = false; // Set this to true to enable auto-slide
  const slideInterval = 3000; // 3 seconds per slide
  const transitionDuration = 350; // Duration of transition in milliseconds

  const sliderHeightControl = container.querySelector(".slider");
  const slides = container.querySelectorAll(".slide-group");
  const dots = container.querySelectorAll(".dot-navigation button");
  const prevArrow = container.querySelector(".prev-arrow");
  const nextArrow = container.querySelector(".next-arrow");
  let currentIndex = 0;
  let autoSlide;

  // Function to adjust the container height based on the active slide
  function adjustContainerHeight() {
    const activeSlide = container.querySelector(".slide-group.active");
    if (activeSlide) {
      const slideHeight = activeSlide.offsetHeight;
      sliderHeightControl.style.height = `${slideHeight}px`;
    }
  }

  function adjustContainerHeightWhenReady() {
    const activeSlide = container.querySelector(".slide-group.active");
    if (!activeSlide) return;

    const images = activeSlide.querySelectorAll("img");
    let imagesLoaded = 0;

    if (images.length === 0) {
      adjustContainerHeight();
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        imagesLoaded++;
      } else {
        img.addEventListener("load", () => {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            adjustContainerHeight();
          }
        });
        img.addEventListener("error", () => {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            adjustContainerHeight();
          }
        });
      }
    });

    if (imagesLoaded === images.length) {
      adjustContainerHeight();
    }
  }

  // Consolidated class remover for previous slide
  function removePreviousClasses(currentSlide, transitionClass) {
    if (currentSlide) {
      currentSlide.classList.remove("active");
      setTimeout(() => {
        currentSlide.classList.remove(transitionClass);
      }, transitionDuration);
    }
  }

  // Function to activate the current slide and the corresponding dot
  function setActiveSlide(index, direction) {
    const currentSlide = container.querySelector(".slide-group.active");
    const nextSlide = slides[index];
    const currentDot = container.querySelector(".dot-navigation button.active");
    const nextDot = dots[index]; // Check if the corresponding dot exists

    // Remove previous transition classes
    slides.forEach((slide) =>
      slide.classList.remove(
        "transition-forward",
        "transition-back",
        "transition-from-forward",
        "transition-from-back"
      )
    );

    // Determine the direction of the transition (forward or back)
    const transitionClass =
      direction === "forward" ? "transition-forward" : "transition-back";
    const slideInClass =
      direction === "forward"
        ? "transition-from-forward"
        : "transition-from-back";

    // Add transition-out class to the current active slide
    if (currentSlide) {
      currentSlide.classList.add(transitionClass);
    }

    // Remove active and transition classes from only the previous slide and dot
    removePreviousClasses(currentSlide, transitionClass);

    // Handle dot changes only if `nextDot` exists
    if (currentDot) {
      currentDot.classList.remove("active"); // Remove active class from current dot
    }

    if (nextDot) {
      nextDot.classList.add("active"); // Add active class to the new dot if it exists
    }

    // Add the incoming slide class based on direction
    nextSlide.classList.add(slideInClass);

    // Wait for the transition-out to finish, then add transition-in and active class to the new slide
    setTimeout(() => {
      nextSlide.classList.add("active", "transition-in");
      adjustContainerHeightWhenReady(); // Adjust the container height after the transition
      // Remove transition-in and slide-in classes after the transition duration
      setTimeout(() => {
        nextSlide.classList.remove("transition-in");
        nextSlide.classList.remove(slideInClass);
      }, transitionDuration / 2);
    }, transitionDuration / 2); // Wait for the transition-out to finish
  }

  // Function to move to the next slide
  function goToNextSlide() {
    const nextIndex = (currentIndex + 1) % slides.length;
    setActiveSlide(nextIndex, "forward");
    currentIndex = nextIndex; // Update currentIndex
  }

  // Function to move to the previous slide
  function goToPrevSlide() {
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    setActiveSlide(prevIndex, "back");
    currentIndex = prevIndex;
  }

  // Function to reset the auto-slide interval after any action
  function resetAutoSlide() {
    if (autoSlideEnabled) {
      clearInterval(autoSlide); // Clear existing interval
      autoSlide = setInterval(goToNextSlide, slideInterval); // Restart interval immediately
    }
  }

  // Initialize auto-slide only if enabled
  if (autoSlideEnabled) {
    autoSlide = setInterval(goToNextSlide, slideInterval);
  }

  // Click event listeners for dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      const direction = index > currentIndex ? "forward" : "back";
      setActiveSlide(index, direction);
      currentIndex = index; // Update currentIndex to clicked slide
      if (autoSlideEnabled) {
        resetAutoSlide(); // Restart auto-slide after manual interaction only if enabled
      }
    });
  });

  // Click event listeners for arrows
  if (prevArrow) {
    prevArrow.addEventListener("click", () => {
      goToPrevSlide();
      if (autoSlideEnabled) {
        resetAutoSlide();
      }
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener("click", () => {
      goToNextSlide();
      if (autoSlideEnabled) {
        resetAutoSlide();
      }
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  // Debounce the resize event to only trigger after resizing has stopped
  const debouncedResizeHandler = debounce(adjustContainerHeight, 250); // Adjust the delay (250ms here) as needed

  window.addEventListener("resize", debouncedResizeHandler);

  // Initial container height adjustment based on first slide
  adjustContainerHeightWhenReady();
}
